{
  "startup": {
    "loading": "Opening your data…",
    "errorTitle": "The app could not open its data",
    "errorBody": "Close the app completely and open it again. If you see this again, tell your office.",
    "errorDetails": "Technical details: {{message}}"
  },
  "welcome": {
    "purpose": "Prepare your vessel for the RISQ inspection: your questions, status, notes and photos. Works without internet.",
    "continue": "Continue"
  },
  "home": {
    "title": "Home",
    "noVesselTitle": "No vessel yet",
    "noVesselBody": "After you sign in, your vessel, your position and your questions appear here.",
    "openDemo": "Open demo vessel",
    "settings": "Settings",
    "you": "You: {{position}}",
    "progressMine": "My questions: {{done}} of {{total}} done ({{percent}}%)",
    "progressVessel": "Whole vessel: {{done}} of {{total}} done ({{percent}}%)",
    "progressEngine": "Engine questions: {{done}} of {{total}} done ({{percent}}%)",
    "thisWeek": "This week ({{count}})",
    "doNow": "What to do now ({{count}})",
    "allMine": "All my questions",
    "allVessel": "All vessel questions",
    "allEngine": "All engine questions",
    "vesselProgress": "Vessel progress",
    "inspectionDate": "Inspection date",
    "showTitle": "Show",
    "showVessel": "Whole vessel",
    "showMine": "My questions",
    "showHint": "Only changes what you see. Your rights stay the same. In Whole vessel, engine room questions are at the bottom.",
    "pending_one": "{{count}} change saved on the phone, waiting to be sent",
    "pending_other": "{{count}} changes saved on the phone, waiting to be sent",
    "lastVoyage": "Last voyage started",
    "finalChecks": "Final checks ({{done}} of {{total}} done)",
    "finalChecksQuestions": "Final checks: C/L questions ({{count}})"
  },
  "settings": {
    "title": "Settings",
    "language": "Language",
    "textSizeTitle": "Text size",
    "textSizeBody": "To make the text larger, change the text size in your phone settings. Opti-Sea follows it.",
    "about": "About Opti-Sea"
  },
  "about": {
    "title": "About",
    "version": "Version {{version}}",
    "purpose": "Opti-Sea helps the crew of bulk carriers prepare for the RISQ inspection."
  },
  "inspection": {
    "notSetTitle": "Inspection date not set",
    "notSetMaster": "Set the planned inspection date. Then the app shows what to do now.",
    "notSetOfficer": "The Master sets the planned inspection date. Then the app shows what to do now.",
    "planned": "Inspection: {{date}}",
    "daysLeft_one": "in {{count}} day",
    "daysLeft_other": "in {{count}} days",
    "today": "today",
    "passedTitle": "The planned date has passed",
    "passedBody": "The inspection was planned for {{date}}. The Master sets the next date.",
    "next": "Next: {{timing}} from {{date}}.",
    "phase": {
      "early": "Too early for preparation flags",
      "six_months": "Now: 6-month preparation",
      "three_months": "Now: 3-month preparation",
      "last": "Now: the last voyage",
      "final_24h": "Now: the last 24 hours",
      "passed": "Everything still open"
    },
    "phaseBody": {
      "early": "Questions marked 6-m start on {{date}}.",
      "six_months": "Work on questions marked 6-m.",
      "three_months": "Work on questions marked 3-m. Questions marked 6-m that are still open come first.",
      "last": "Work on questions marked Last. Earlier questions that are still open come first.",
      "final_24h": "Questions marked C/L, and everything still open.",
      "passed": "All questions with a preparation flag that are still open."
    },
    "editTitle": "Inspection date",
    "editBody": "Planned RISQ inspection of {{vessel}}. Everyone on board sees it. It decides what the app shows under \"What to do now\".",
    "day": "Day",
    "month": "Month",
    "year": "Year",
    "invalid": "Enter a real date from today up to two years ahead.",
    "preview": "Preparation starts",
    "previewTiming": "{{timing}}: {{date}}",
    "plannedWhen": "Inspection: {{date}} — {{when}}",
    "lastVoyageSince": "Last voyage since {{date}}.",
    "lastVoyageDefault": "Last starts 7 days before the inspection unless the Master records the start of the last voyage."
  },
  "due": {
    "now": "Now",
    "started": "Started earlier — catch up",
    "later": "Later — starts closer to the inspection"
  },
  "lists": {
    "mine": "My questions",
    "vessel": "Whole vessel",
    "engine": "Engine questions",
    "week": "This week",
    "now": "What to do now",
    "section": "Section {{code}}",
    "sectionProgress": "{{done}} of {{total}} done ({{percent}}%)",
    "count_one": "{{count}} question",
    "count_other": "{{count}} questions",
    "emptyWeek": "No questions of the week for you. The office chooses them.",
    "emptyNow": "Nothing to do now with the current filter.",
    "emptyNoDate": "The inspection date is not set, so the app cannot tell what to do now.",
    "empty": "No questions here with the current filter.",
    "filter": "Filter",
    "filterNone": "Filter: all questions",
    "filterActive": "Filter: {{list}}",
    "clearFilter": "Clear filter",
    "responsible": "Responsible: {{positions}}",
    "unassigned": "Nobody yet",
    "checkAgain": "Check again — question changed",
    "flags": "{{list}}",
    "engineGroup": "Engine room ({{count}})",
    "engineShow": "Show engine room questions ({{count}})",
    "engineHide": "Hide engine room questions"
  },
  "filters": {
    "title": "Filter questions",
    "workTypes": "Type of work",
    "timings": "When to prepare",
    "hint": "Choose one or more. A question is shown when it has one of the chosen marks.",
    "show_one": "Show {{count}} question",
    "show_other": "Show {{count}} questions",
    "clear": "Clear filter",
    "selected": "Selected",
    "notSelected": "Not selected"
  },
  "question": {
    "title": "Question {{code}}",
    "section": "Section {{code}}",
    "responsible": "Responsible",
    "sourceVessel": "Changed for this vessel",
    "sourceCompany": "Company setting",
    "sourceBase": "From the master file",
    "workTypes": "Type of work",
    "timings": "When to prepare",
    "noFlags": "No marks",
    "advice": "Advice",
    "lastNote": "Last note",
    "attention": "Changed by two people — check",
    "changeStatus": "Change status",
    "checklist": "What to check ({{checked}} of {{total}})",
    "checklistEmpty": "What to check",
    "addNote": "Add note",
    "guidance": "Inspector guidance",
    "history": "History",
    "reassign": "Reassign",
    "notFound": "Question not found",
    "notFoundBody": "This question is not on your phone any more. Go back to the list.",
    "timingDefault": "No time flag in the master file: counted as 3-m",
    "flagSourceCompany": "Marks set by your company",
    "timingLine": "{{short}} — {{meaning}}"
  },
  "status": {
    "title": "Change status",
    "current": "Current",
    "hint": "Question {{code}}",
    "option": "{{icon}}  {{word}}"
  },
  "note": {
    "title": "Add note",
    "label": "Your note",
    "hint": "Question {{code}}. The note is saved with your name and position."
  },
  "checklist": {
    "title": "What to check",
    "progress": "{{checked}} of {{total}} ticked",
    "checked": "Checked",
    "notChecked": "Not checked",
    "companyPoint": "Company point",
    "empty": "This question has no check points yet.",
    "imsTitle": "Company IMS references",
    "imsHint": "From your company, not part of RISQ."
  },
  "guidance": {
    "title": "Inspector guidance",
    "empty": "No inspector guidance for this question.",
    "sectionTitle": "About section {{code}}"
  },
  "history": {
    "title": "History",
    "empty": "Nothing has happened to this question yet.",
    "status": "{{from}} → {{to}}",
    "statusFirst": "Status: {{to}}",
    "note": "Note: {{text}}",
    "checked": "Ticked: {{point}}",
    "unchecked": "Unticked: {{point}}",
    "pointGone": "a check point that was removed",
    "positionsSet": "Responsible: {{from}} → {{to}}",
    "positionsRevert": "Returned to the {{source}}: {{to}}",
    "layerVessel": "Changed for this vessel",
    "layerCompany": "Changed for the company",
    "sourceCompany": "company setting",
    "sourceBase": "master file",
    "by": "{{name}}, {{position}} · {{time}}",
    "byRole": "{{name}} ({{role}}) · {{time}}",
    "unknownPerson": "Someone",
    "roles": {
      "admin": "Admin",
      "dpa": "Office",
      "master": "Master",
      "service": "System"
    }
  },
  "reassign": {
    "title": "Reassign question",
    "now": "Question {{code}}. Responsible now: {{positions}}",
    "body": "Choose who is responsible on {{vessel}}. Only this vessel changes. The change is saved on the phone, sent to the office and kept in the history.",
    "current": "Now",
    "revertCompany": "Return to the company setting: {{positions}}",
    "revertBase": "Return to the master file: {{positions}}",
    "continue": "Continue",
    "confirmTitle": "Reassign {{code}}?",
    "confirmBody": "From {{from}} to {{to}} on {{vessel}}. The question leaves the list of {{from}} and appears in the list of {{to}}.",
    "confirm": "Reassign",
    "revertTitle": "Return {{code}}?",
    "revertBody": "Responsible on {{vessel}} again: {{to}} ({{source}}). The change for this vessel is removed; the history keeps it.",
    "revertConfirm": "Return"
  },
  "vesselProgress": {
    "title": "Vessel progress",
    "byPosition": "By position",
    "unassigned": "Not assigned to a position",
    "byPhase": "By preparation flag",
    "positionLine": "{{done}} done, {{left}} left",
    "phaseLine": "{{done}} of {{total}} done ({{percent}}%)",
    "phaseTitle": "{{short}} — {{meaning}}",
    "noQuestions": "No questions",
    "phaseHint": "Questions without a time flag count as 3-m."
  },
  "demo": {
    "title": "Demo vessel",
    "body": "Sign-in comes in a later version. To try the app now, open a demo vessel with the real RISQ 3.2 questions. The demo stays on this phone and is never sent.",
    "choose": "Who are you on board?",
    "open": "Open demo vessel",
    "restartTitle": "Start the demo again?",
    "restartBody": "Your demo changes on this phone are removed and the demo starts from the beginning.",
    "restart": "Start again",
    "settingsRow": "Demo vessel",
    "settingsHint": "Until sign-in is ready"
  },
  "lastVoyage": {
    "title": "Last voyage",
    "body": "When {{vessel}} starts the last voyage before the inspection, record it here. From that day everyone on board sees the questions marked Last in \"What to do now\".",
    "inspection": "Inspection: {{date}}",
    "startedToday": "Last voyage started today",
    "otherDay": "Or enter the day the voyage started",
    "saveDay": "Save this day",
    "invalid": "Enter a real date: not in the future and not more than 6 months before the inspection.",
    "current": "Recorded: last voyage since {{date}}",
    "clear": "Remove the last voyage",
    "noInspection": "Set the planned inspection date first."
  },
  "finalChecks": {
    "title": "Final checks",
    "inspection": "Inspection {{date}} ({{when}})",
    "today": "today",
    "tomorrow": "tomorrow",
    "progress": "{{done}} of {{total}} done ({{percent}}%)",
    "closedTitle": "Final checks are not open",
    "closedBody": "They open on {{date}}, the day before the planned inspection.",
    "noInspection": "The Master sets the planned inspection date first.",
    "intro": "The company's list for the last day. Tap an item when it is done. Ticks belong to the inspection on {{date}}; a new date starts a fresh list.",
    "noGroups": "Your position has no items in the company's list. Check your C/L questions below.",
    "when": {
      "day_before": "1 day before",
      "hour_before": "1 hour before the deck inspection"
    },
    "tickedBy": "Ticked by: {{positions}}",
    "groupProgress": "{{done}} of {{total}} done",
    "done": "Done",
    "notDone": "Not done",
    "linked": "RISQ {{codes}}",
    "doneBy": "Done by {{position}} at {{time}}",
    "valueEmpty": "{{label}}: not entered",
    "valueSet": "{{label}}: {{value}}",
    "enterValue": "Enter",
    "questionsTitle": "RISQ questions for the last 24 hours (C/L)",
    "questionsEmpty": "No C/L questions in your list.",
    "valueTitle": "Final check",
    "valueSave": "Save",
    "valueClear": "Remove the entry",
    "valueText": "Text",
    "invalidDate": "Enter a real date, not later than today.",
    "invalidText": "Enter 1 to 200 characters."
  }
}
